"use client";
import React from "react";

type TimelineNavProps = {
  years: number[];
  activeIndex: number;
  // eslint-disable-next-line no-unused-vars
  onSelect: (_index: number) => void;
};

export default function TimelineNav({
  years,
  activeIndex,
  onSelect,
}: TimelineNavProps) {
  const viewportCenterX =
    typeof window !== "undefined" ? window.innerWidth / 2 - 200 : 0;
  return (
    <nav className="pointer-events-auto absolute left-0 right-0 bottom-8 md:bottom-12 pl-6 md:pl-16">
      <div className="overflow-hidden">
        <div
          className="timeline-track relative inline-flex min-w-max items-center gap-16 py-6"
          id="timelineTrack"
          style={{ transform: `translateX(${viewportCenterX}px)` }}
        >
          <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-px bg-white/15"></div>
          {years?.map((year, idx) => {
            const isActive = idx === activeIndex;
            return (
              <button
                type="button"
                aria-label={`Select year ${year}`}
                key={year}
                className="year-item relative shrink-0 w-[120px] flex flex-col items-center"
                onClick={() => onSelect(idx)}
              >
                <div
                  className={
                    "dot transition-all rounded-full " +
                    (isActive
                      ? "w-5 h-5 bg-white shadow-md"
                      : "w-3.5 h-3.5 bg-transparent border border-white/30")
                  }
                ></div>
                <div
                  className={`mt-3 text-xs md:text-sm ${isActive ? "text-white" : "text-white/60"}`}
                >
                  {year}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
